"use client";

import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import MemesQuickVoteActionBar from "./MemesQuickVoteActionBar";
import MemesQuickVoteDescription from "./MemesQuickVoteDescription";
import MemesQuickVoteDropHeader from "./MemesQuickVoteDropHeader";
type VoteFeedbackSource = "custom-submit" | "quick-amount";
interface MemesQuickVoteControlsProps {
  readonly customValue: string;
  readonly drop: ExtendedDrop;
  readonly feedbackAmount: number | null;
  readonly feedbackSource: VoteFeedbackSource | null;
  readonly isCustomOpen: boolean;
  readonly isSubmitting: boolean;
  readonly isVoteFeedbackActive: boolean;
  readonly latestUsedAmount: number | null;
  readonly remainingCount: number;
  readonly quickAmounts: readonly number[];
  readonly uncastPower: number | null;
  readonly votingLabel: string | null;
  readonly onCustomChange: (value: string) => void;
  readonly onCustomSubmit: () => void;
  readonly onOpenCustom: () => void;
  readonly onSkip: () => void;
  readonly onVoteAmount: (amount: number) => void;
}
export default function MemesQuickVoteControls(t0) {
  const $ = _c(40);
  const {
    customValue,
    drop,
    feedbackAmount,
    feedbackSource,
    isCustomOpen,
    isSubmitting,
    isVoteFeedbackActive,
    latestUsedAmount,
    remainingCount,
    quickAmounts,
    uncastPower,
    votingLabel,
    onCustomChange,
    onCustomSubmit,
    onOpenCustom,
    onSkip,
    onVoteAmount
  } = t0;
  const title = drop.metadata.find(_temp)?.data_value ?? "Untitled submission";
  const description = drop.metadata.find(_temp2)?.data_value ?? "";
  let t1;
  if ($[0] !== remainingCount) {
    t1 = formatNumberWithCommas(remainingCount);
    $[0] = remainingCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-hidden tw-shrink-0 tw-flex-wrap tw-gap-2 tw-px-8 md:tw-flex md:tw-pb-6 md:tw-pt-6"><span className="tw-rounded-full tw-border tw-border-solid tw-border-white/5 tw-bg-white/[0.03] tw-px-4 tw-py-1.5 tw-text-[13px] tw-font-bold tw-text-iron-300 tw-shadow-sm tw-backdrop-blur-md">{t1} unrated</span></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop) {
    t3 = <MemesQuickVoteDropHeader drop={drop} />;
    $[4] = drop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <h2 className="tw-mb-3 tw-mt-4 tw-text-2xl tw-font-semibold tw-leading-tight tw-tracking-tight tw-text-white md:tw-text-3xl">{title}</h2>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== description || $[9] !== drop.id) {
    t5 = description && <MemesQuickVoteDescription key={drop.id} description={description} />;
    $[8] = description;
    $[9] = drop.id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="tw-[scrollbar-gutter:stable] tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-pb-16 tw-scrollbar-thin tw-scrollbar-track-transparent tw-scrollbar-thumb-iron-700/60 desktop-hover:hover:tw-scrollbar-thumb-iron-600/80 md:tw-px-8"><div className="tw-flex tw-w-full tw-flex-col tw-gap-5">{t3}{t6}</div></div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-pointer-events-none tw-absolute tw-inset-x-8 tw-bottom-0 tw-h-16 tw-bg-gradient-to-t tw-from-[#0a0a0a] tw-via-[#0a0a0a]/85 tw-to-transparent" />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7) {
    t9 = <div className="tw-relative tw-hidden tw-min-h-0 tw-flex-1 md:tw-flex">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== customValue || $[21] !== feedbackAmount || $[22] !== feedbackSource || $[23] !== isCustomOpen || $[24] !== isSubmitting || $[25] !== isVoteFeedbackActive || $[26] !== latestUsedAmount || $[27] !== onCustomChange || $[28] !== onCustomSubmit || $[29] !== onOpenCustom || $[30] !== onSkip || $[31] !== onVoteAmount || $[32] !== quickAmounts || $[33] !== uncastPower || $[34] !== votingLabel) {
    t10 = <MemesQuickVoteActionBar customValue={customValue} feedbackAmount={feedbackAmount} feedbackSource={feedbackSource} isCustomOpen={isCustomOpen} isSubmitting={isSubmitting} isVoteFeedbackActive={isVoteFeedbackActive} latestUsedAmount={latestUsedAmount} quickAmounts={quickAmounts} uncastPower={uncastPower} votingLabel={votingLabel} onCustomChange={onCustomChange} onCustomSubmit={onCustomSubmit} onOpenCustom={onOpenCustom} onSkip={onSkip} onVoteAmount={onVoteAmount} />;
    $[20] = customValue;
    $[21] = feedbackAmount;
    $[22] = feedbackSource;
    $[23] = isCustomOpen;
    $[24] = isSubmitting;
    $[25] = isVoteFeedbackActive;
    $[26] = latestUsedAmount;
    $[27] = onCustomChange;
    $[28] = onCustomSubmit;
    $[29] = onOpenCustom;
    $[30] = onSkip;
    $[31] = onVoteAmount;
    $[32] = quickAmounts;
    $[33] = uncastPower;
    $[34] = votingLabel;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t2 || $[38] !== t9) {
    t11 = <div data-testid="quick-vote-controls-desktop-context" className="tw-flex tw-shrink-0 tw-flex-col tw-gap-0 md:tw-h-full md:tw-min-h-0 md:tw-overflow-hidden md:tw-bg-[#0a0a0a]/30">{t2}{t9}{t10}</div>;
    $[36] = t10;
    $[37] = t2;
    $[38] = t9;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  return t11;
}
function _temp2(entry_0) {
  return entry_0.data_key === "description";
}
function _temp(entry) {
  return entry.data_key === "title";
}